import { Component, OnInit } from '@angular/core';
import { WeCumplimientoService } from 'src/app/wecumplimiento/shared/services/WeCumplimiento.service';

@Component({
  selector: 'app-wecumplimiento-layout',
  templateUrl: './wecumplimiento-layout.component.html'
})
export class WeCumplimientoLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
